class RealLessonNav extends HTMLElement {
  connectedCallback() {
    this.toggleButton = this.querySelector('.real-lesson-nav__mobile-toggle');
    this.onToggleClick = this.handleToggleClick.bind(this);
    this.onKeydown = this.handleKeydown.bind(this);

    if (this.toggleButton) {
      this.toggleButton.addEventListener('click', this.onToggleClick);
    }

    this.addEventListener('keydown', this.onKeydown);
    this.syncMobileToggleLabel();

    window.requestAnimationFrame(() => this.scrollActiveLinkIntoView());
  }

  disconnectedCallback() {
    if (this.toggleButton) {
      this.toggleButton.removeEventListener('click', this.onToggleClick);
    }

    this.removeEventListener('keydown', this.onKeydown);
  }

  handleToggleClick() {
    const isOpen = !this.classList.contains('real-lesson-nav--mobile-open');

    this.classList.toggle('real-lesson-nav--mobile-open', isOpen);
    this.toggleButton?.setAttribute('aria-expanded', isOpen.toString());
  }

  handleKeydown(event) {
    if (event.key !== 'Escape' || !this.classList.contains('real-lesson-nav--mobile-open')) return;

    this.classList.remove('real-lesson-nav--mobile-open');
    this.toggleButton?.setAttribute('aria-expanded', 'false');
    this.toggleButton?.focus();
  }

  syncMobileToggleLabel() {
    const activeLink = this.querySelector(
      '.real-lesson-nav__item:not(.real-lesson-nav__item--mobile-home) .real-lesson-nav__link--active'
    );
    const toggleLabel = this.querySelector('[data-real-lesson-nav-toggle-label]');
    const activeLabel = activeLink?.getAttribute('aria-label') || activeLink?.textContent?.trim();

    if (toggleLabel && activeLabel) toggleLabel.textContent = activeLabel;
  }

  scrollActiveLinkIntoView() {
    const scroller = this.querySelector('.real-lesson-nav__scroller');
    const activeLink = scroller?.querySelector('.real-lesson-nav__link--active');

    if (!scroller || !activeLink || scroller.offsetParent === null) return;

    const scrollerRect = scroller.getBoundingClientRect();
    const linkRect = activeLink.getBoundingClientRect();
    const currentScroll = scroller.scrollLeft;
    const targetScroll =
      currentScroll + linkRect.left - scrollerRect.left - (scrollerRect.width - linkRect.width) / 2;

    scroller.scrollLeft = Math.max(0, targetScroll);
  }
}

if (!customElements.get('real-lesson-nav')) {
  customElements.define('real-lesson-nav', RealLessonNav);
}
